// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"fd18cef2","221":"67c33852"}[chunkId] + ".chunk.css";
};